import React, {useState, useEffect} from 'react';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile;
}

function HighlightCard(props) {

    const isMobile = useIsMobile();



  return (
    <>
        <div class="card text-center" style={{width: isMobile ? "80%" : "30%", margin: "auto", marginTop: "20px"}}>
            <div class="card-header">
                {props.unit}
            </div>
            <div class="card-body">
                <h5 class="card-title">{props.title}</h5>
                <img src={props.image} className="card-img-top" alt="Loading..." style={{width: "100%"}} />
            </div>
            <div class="card-footer text-muted">
                {props.creator}
            </div>
        </div>
    </>
    
  );
}

export default HighlightCard;